var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBridge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 68,
    viewBox: "0 0 96 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M48.333 31.75C25.833 31.75 12.333 9.25 12.333 9.25L3.33301 20.5M48.333 31.75C70.833 31.75 84.333 9.25 84.333 9.25L93.333 20.5M48.333 31.75V47.5M12.333 2.5V65.5M84.333 2.5V65.5M3.33301 48.625C3.33301 48.625 30.7553 47.2809 48.333 47.5M48.333 47.5C65.9271 47.7194 93.333 49.75 93.333 49.75M30.333 27.25V47.5M66.333 27.25V47.5",
    stroke: "url(#paint0_linear_310_32859)",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_310_32859",
    x1: 3.33301,
    y1: 34,
    x2: 93.3325,
    y2: 34.2133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D129DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CDBFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridge);
export default __webpack_public_path__ + "static/media/bridge.2c744d600fdb07cc31a33ef7b0322419.svg";
export { ForwardRef as ReactComponent };